@file:OptIn(InternalResourceApi::class)

package partejar_app.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.FontResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/partejar_app.shared.generated.resources/"

@delegate:ResourceContentHash(2_098_119_172)
internal val Res.font.OFL: FontResource by lazy {
      FontResource("font:OFL", setOf(
        ResourceItem(setOf(), "${MD}font/OFL.txt", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-404_647_057)
internal val Res.font.quicksand_variable: FontResource by lazy {
      FontResource("font:quicksand_variable", setOf(
        ResourceItem(setOf(), "${MD}font/quicksand_variable.ttf", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainFont0Resources(map: MutableMap<String, FontResource>) {
  map.put("OFL", Res.font.OFL)
  map.put("quicksand_variable", Res.font.quicksand_variable)
}
